import { IMergedRateCard } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const getPayeeEngagementRateCardByPayee = async (
  payeeId: string,
  payeeEngagementId: string
): Promise<IMergedRateCard | null> => {
  try {
    const response = await servicePayments.get(
      `/payee/${payeeId}/engagement/${payeeEngagementId}/rate-card`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
